import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikProps } from 'formik';
import { object, string } from 'yup';
import OrderFilterDialog from './OrderFilterDialog';
import {
   setDateFilter
  } from "src/redux/slices/OfflineOrderSlice";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import moment from 'moment';
type Props = {
  onClose: () => void;
};
 export type  FilterDialogWrapperValues ={
    startDate :any ,
    endDate:any
}

const OrderFilterDialogWrapper = ({ onClose }: Props) => { 
  const dispatch = useDispatch()
    const ticketState = useSelector((state: RootState) => state.offlineOrder);
    const { dateFilter } =
      ticketState;
  // Form Initial Values
  const initialValues: FilterDialogWrapperValues = {
    startDate :dateFilter.startDate || '' ,
    endDate:dateFilter.endDate || ''
  };

  // Validation Schema
  const validationSchema = object().shape({
    startDate: string().required("please select start date"),
    endDate: string().required("please select end date"),
  });

  // Handle Submit
  const handleSubmit = (
    values: FilterDialogWrapperValues,
  ) => {
   // created date from to dispatch
   dispatch(
    setDateFilter({
        startDate: values.startDate
        ? moment(values.startDate)?.format("yyyy-MM-DD")
        : "",
        endDate: values.endDate
        ? moment(values.endDate)?.format("yyyy-MM-DD")
        : "",
    })
  );
  onClose();
  }; 

  const handleReset =async (formikProps: FormikProps<FilterDialogWrapperValues>) => {
     // created date filter dispatch
     await dispatch(
        setDateFilter({
            startDate: "",
            endDate: "",
        })
      );
      formikProps.resetForm()
  
  }

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
      enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <OrderFilterDialog formikProps={formikProps} onClose={onClose} onReset={() => handleReset(formikProps)} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default OrderFilterDialogWrapper;